import { render } from "./security.vue?vue&type=template&id=2a0655d1&scoped=true"
import script from "./security.vue?vue&type=script&lang=js"
export * from "./security.vue?vue&type=script&lang=js"

import "../less/profileSettings.less?vue&type=style&index=0&id=2a0655d1&scoped=true&lang=css&external"
import "./security.vue?vue&type=style&index=1&id=2a0655d1&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a0655d1"]])

export default __exports__